// prop-types is a library for typechecking of props
import propTypes from 'prop-types';
// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 React components
// Material Dashboard 2 React example components
// Data to delete
// import currencysTableData from "layouts/tables/data/currencysTableData";
import {
  Box,
  Pagination,
  Paper,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography
} from '@mui/material';

import { useEffect, useState } from 'react';
// eslint-disable-next-line
import { useDispatch, useSelector } from 'react-redux';

import { Spinner } from '../../../components/Spinner';
import ApiService from '../../../helpers/apiHelper';

import { setIsOpenServicePromoteModal } from '../../../redux/mainReducer';
import { LetsGoBtn } from '../../../components/Buttons';

function createTableData(serviceName, oQty, rating, sales, wQty, templateData) {
  return {
    serviceName,
    oQty,
    rating,
    sales,
    wQty,

    templateData
  };
}

function Row({ row, refreshData }) {
  const dispatch = useDispatch();

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="left">
          {/* <CustomWidthTooltip title={row.id} placement="right" sx={{ width: '10px' }}> */}

          <Typography
            onClick={() => {
              window.open(`/ua/service/${row.templateData.id}`);
            }}
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,
              fontFamily: 'FixelText-Regular !important',
              textTransform: 'uppercase',
              color: '#60A5DF',
              width: 'fit-content',
              cursor: 'pointer'
            })}
          >
            {row?.serviceName}
          </Typography>
          <LetsGoBtn
            colorScheme="blue"
            lineHeight={{ xs: '14px', sm: '20px', md: '24px' }}
            margin={{ xs: '8px 0px', sm: '10px 0px', md: '10px 0px' }}
            text="Просувати"
            onClick={() =>
              dispatch(
                setIsOpenServicePromoteModal({
                  isOpen: true,
                  id: row?.templateData?.id,
                  title: row.serviceName,
                  setter: refreshData
                })
              )
            }
          />
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightLight } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: fontWeightLight,
            textTransform: 'uppercase',
            fontFamily: 'FixelText-Regular !important'
            // width: cell.width,
          })}
        >
          <Typography
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,

              fontFamily: 'FixelText-Regular !important',
              textTransform: 'capitalize'
            })}
          >
            {row.oQty}
            {/* {dateTimeFormattingByString(row.creationTimeOfAction)} */}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightLight } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: fontWeightLight,

            fontFamily: 'FixelText-Regular !important',
            textTransform: 'capitalize'
            // width: cell.width,
          })}
        >
          <Typography
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,
              textTransform: 'uppercase',
              fontFamily: 'FixelText-Regular !important',
              width: 'fit-content',
              margin: '0 auto',
              display: 'flex',
              alignItems: 'center'
            })}
          >
            {/*{row?.rating}*/}
            <Rating
              sx={{ fontSize: { xs: '18px', sm: '22px' }, ml: '10px' }}
              name="read-only"
              value={row?.rating}
              precision={0.5}
              readOnly
            />
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightLight } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: fontWeightLight,

            fontFamily: 'FixelText-Regular !important',
            textTransform: 'uppercase'
            // width: cell.width,
          })}
        >
          <Typography
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,

              fontFamily: 'FixelText-Regular !important',
              textTransform: 'capitalize',
              width: 'fit-content',
              margin: '0 auto'
            })}
          >
            {`${row.sales} грн`}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightLight } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: fontWeightLight,

            fontFamily: 'FixelText-Regular !important',
            textTransform: 'uppercase'
            // width: cell.width,
          })}
        >
          <Typography
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,

              fontFamily: 'FixelText-Regular !important',
              textTransform: 'capitalize'
            })}
          >
            {`${row.wQty}`}
          </Typography>
        </TableCell>

        {/* <TableCell align="center"> */}
        {/* <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </Button> */}
        {/* <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                editRow(row, "block");
                handleClose();
              }}
            >
              <BlockIcon
                sx={{ fontSize: "14px !important", cursor: "pointer", mr: 1 }}
              />
              {row?.templateData?.isBlockedPost
                ? "Розблокувати"
                : "Заблокувати"}
            </MenuItem>
            {userData && userData?.role && userData?.role !== "ADMIN" && (
              <MenuItem
                onClick={() => {
                  editRow(row, "edit");
                  handleClose();
                }}
              >
                <EditIcon
                  sx={{
                    fontSize: "14px !important",
                    cursor: "pointer",
                    mr: 1,
                  }}
                />
                <Typography>Змінити</Typography>
              </MenuItem>
            )}

            <MenuItem
              onClick={() => {
                editRow(row, "delete");
                handleClose();
              }}
            >
              <DeleteOutlineIcon
                sx={{ fontSize: "14px !important", cursor: "pointer", mr: 1 }}
              />
              Видалити
            </MenuItem>
          </Menu> */}

        {/* <Typography
            sx={({ typography: { size, fontWeightBold } }) => ({
              fontSize: size.xxs,
              fontWeight: fontWeightBold,
              textTransform: "uppercase",
            })}
          > */}
        {/* </TableCell> */}
      </TableRow>
    </>
  );
}

function ServicesTable() {
  const userData = useSelector((state) => state.global.userData);
  // eslint-disable-next-line
  // const [selectedRow, setSelectedRow] = useState(null);
  const [pagesCount, setPagesCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [sortDirection, setSortDirection] = useState('DESC');
  const [sortField, setSortField] = useState('NAME_SORT');
  // eslint-disable-next-line

  // eslint-disable-next-line
  const dispatch = useDispatch();

  const apiGetServices = new ApiService('posts/service/service-statistic');
  // const apiGetServices = new ApiService('service/service-statistic');

  const tableCells = [
    { header: 'Товар', align: 'left', width: '130px', label: 'NAME_SORT' },
    {
      header: 'Продано',
      align: 'center',
      width: '120px',
      label: 'NUMBER_OF_ORDERS_SORT',
      padding: '23px'
    },
    { header: 'Рейтинг', align: 'center', width: '130px', label: 'RATING_SORT', padding: '40px' },
    { header: 'Дохід', align: 'center', width: '115px', label: 'SALES_SORT', padding: '40px' },
    {
      header: 'Збережень',
      align: 'center',
      width: '140px',
      label: 'NUMBER_OF_SAVED_SORT',
      padding: '30px'
    }
    // { header: 'Дії', align: 'center', label: 'date' }
  ];

  const [rows, setRows] = useState([
    // {
    //   serviceName: 'test',
    //   wQty: 2,
    //   oQty: 10,
    //   rating: 5,
    //   sales: 2
    // }
  ]);

  const handleGetServices = () => {
    setIsLoading(true);
    apiGetServices
      .getAll({
        page: offset,
        size: 10,
        fieldBySort: sortField,
        sortDirection: sortDirection
      })

      .then((res) => {
        const rows = res.result.map((row) => {
          return createTableData(
            row.nameService,
            row.numberOfOrders,
            row.rating,
            row.sales,
            row.numberOfSaved,
            row
          );
        });
        setRows(rows);
        setPagesCount(
          Number.isInteger(res.count / 10) ? res.count / 10 : Math.floor(+(res.count / 10)) + 1
        );
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  // const searchFunction = (searchValue) => {
  //   setIsLoading(true);
  //   if (searchValue && searchValue.length !== 0) {
  //     apiGetServices
  //       .getAll({
  //         startWith: 0,
  //         count: 10,
  //         searchString: searchValue ? searchValue : '',
  //         filterWithAdminActionType: isFilter,
  //         adminActionType: filterBy?.enum && isFilter ? filterBy?.enum : ''
  //       })
  //       .then((res) => {
  //         const rows = res.result.map((row) => {
  //           return createTableData(
  //             row.id,
  //             row.description,
  //             row.creationTimeOfAction,
  //             row.valueLikes,
  //             row.numberComments,
  //             row
  //           );
  //         });
  //         setRows(rows);
  //         setPagesCount(
  //           Number.isInteger(res.count / 10) ? res.count / 10 : Math.floor(+(res.count / 10)) + 1
  //         );
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     handleGetServices();
  //   }
  // };

  useEffect(() => {
    if (userData && userData?.id) {
      handleGetServices();
    }
    // dispatch(setIsOpenSearchBar(true));
    // eslint-disable-next-line
  }, [userData, offset, sortField, sortDirection]);
  return (
    <Grid container spacing={6} sx={{ mb: '20px' }}>
      <Grid item xs={12}>
        <Box pt={2}>
          {/* <DataTable
                  // canSearch
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                /> */}
          {!isLoading ? (
            <>
              {' '}
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: '8px 8px 0px 0px !important',
                  border: '2px solid #F0F0F0',
                  borderBottom: 'none',
                  mt: 1.5
                }}
              >
                <Table>
                  <TableHead
                    sx={{
                      borderRadius: '0px !important',
                      display: 'table-header-group',
                      backgroundColor: '#E2F2FF'
                    }}
                  >
                    <TableRow>
                      {tableCells.map((cell, index) => (
                        <TableCell
                          key={cell.header + cell + index}
                          align={cell.align}
                          sx={{
                            width: cell?.width,
                            maxWidth: cell?.width, // чтобы не превышало
                            minWidth: cell?.width,
                            borderBottom: 'none',
                            fontFamily: 'FixelText-Medium !important',
                            fontSize: { xs: '12px', sm: '14px', md: '16px' },
                            fontWeight: 500,
                            paddingLeft: cell?.padding && cell?.padding
                          }}
                        >
                          {cell.header}
                          {cell?.label === 'NUMBER_OF_ORDERS_SORT' ||
                          cell?.label === 'SALES_SORT' ||
                          cell?.label === 'NUMBER_OF_SAVED_SORT' ||
                          cell?.label === 'RATING_SORT' ||
                          cell?.label === 'NAME_SORT' ? (
                            <TableSortLabel
                              sx={{ cursor: 'pointer' }}
                              active={sortField === cell?.label}
                              direction={sortDirection === 'ASC' ? 'asc' : 'desc'}
                              onClick={() => {
                                if (sortDirection === 'ASC') {
                                  setSortDirection('DESC');
                                } else {
                                  setSortDirection('ASC');
                                }

                                setSortField(cell?.label);
                              }}
                            />
                          ) : null}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <Row key={row.serviceName} row={row} refreshData={handleGetServices} />
                    ))}
                  </TableBody>
                </Table>
                {rows.length === 0 && (
                  <Typography sx={{ m: '150px auto', textAlign: 'center' }}>
                    Товарів не знайдено
                  </Typography>
                )}
              </TableContainer>
              <Pagination
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  m: 0,
                  backgroundColor: 'white',
                  border: '2px solid #F0F0F0',
                  borderRadius: '0px 0px 8px 8px',
                  padding: '5px'
                }}
                defaultPage={1}
                siblingCount={0}
                count={pagesCount}
                shape="rounded"
                page={offset + 1}
                onChange={(event, value) => setOffset(value - 1)}
              />
            </>
          ) : (
            <div style={{ marginTop: '10%', marginBottom: '10%' }}>
              <Spinner type="small" />
            </div>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

Row.propTypes = {
  row: propTypes.object
};
export default ServicesTable;
